const priceFiterHandler = () => {
  const filter = document.querySelector('[data-filter="price"]');

  if (!filter) return;

  const form = document.querySelector('form[name="arFilter_form"]');
  const resetBtn = filter.querySelector('[data-filter="reset"]');
  const inputs = filter.querySelectorAll('input');

  if (!resetBtn || !inputs.length) return;

  const checkInputs = () => {
    let hasValue = false;
    inputs.forEach((input) => {
      if (input.value.trim() !== '') {
        hasValue = true;
      }
    });

    resetBtn.style.display = hasValue ? 'inline-flex' : 'none';
  };

  checkInputs();

  inputs.forEach((input) => {
    input.addEventListener('input', checkInputs);
  });

  resetBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    inputs.forEach((input) => {
      if (input.value) {
        input.value = '';
        input.dispatchEvent(new Event('keyup'));
      }
    });
    form.dispatchEvent(new Event('change'));
    checkInputs();
  });
};

export {priceFiterHandler};
